import { CircleCheck, CircleX, Hourglass } from "lucide-react";

import { cn } from "@/lib/cn";

import { parseProving } from "./proving";

const ICON = {
  proven: CircleCheck,
  failed: CircleX,
  testing: Hourglass,
} as const;

const TONE = {
  light: {
    proven:
      "bg-emerald-600/12 text-emerald-700 ring-emerald-600/25 dark:text-emerald-300",
    failed: "bg-rose-600/12 text-rose-700 ring-rose-600/25 dark:text-rose-300",
    testing:
      "bg-slate-500/12 text-slate-600 ring-slate-500/25 dark:text-slate-300",
  },
  dark: {
    proven: "bg-emerald-400/20 text-emerald-200 ring-emerald-300/30",
    failed: "bg-rose-400/20 text-rose-200 ring-rose-300/30",
    testing: "bg-white/10 text-white/80 ring-white/20",
  },
} as const;

/** The status as a badge (green ✓ Proven, red ✕ Not proven, grey ⏳ Testing), its
 * details, and "Paper trade · not a call or recommendation". */
export function ProvingLabel({
  label,
  dark = false,
  className,
}: {
  label: string | null | undefined;
  dark?: boolean;
  className?: string;
}) {
  const p = parseProving(label);
  const Icon = ICON[p.kind];
  return (
    <p
      data-testid="card-label"
      data-proving={p.kind}
      className={cn(
        "flex flex-wrap items-center gap-x-1.5 gap-y-1 text-2xs leading-snug break-words",
        dark ? "text-white/60" : "text-muted",
        className,
      )}
    >
      <span
        className={cn(
          "inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 font-semibold tracking-wide uppercase ring-1 ring-inset [&_svg]:size-3",
          TONE[dark ? "dark" : "light"][p.kind],
        )}
      >
        <Icon aria-hidden />
        {p.title}
      </span>
      <span className="min-w-0">
        {p.detail} · paper trade · not a call or recommendation
      </span>
    </p>
  );
}
